import { render } from "./arki-technical-task-view.vue?vue&type=template&id=c4e7cf28"
import script from "./arki-technical-task-view.vue?vue&type=script&setup=true&lang=js"
export * from "./arki-technical-task-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/arki/views/document/arki-technical-task-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4e7cf28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4e7cf28', __exports__)) {
    api.reload('c4e7cf28', __exports__)
  }
  
  module.hot.accept("./arki-technical-task-view.vue?vue&type=template&id=c4e7cf28", () => {
    api.rerender('c4e7cf28', render)
  })

}


export default __exports__